import '../css/app.css';

import { createInertiaApp } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createRoot } from 'react-dom/client';
import { route as routeFn } from 'ziggy-js';
import { initializeTheme } from './hooks/use-appearance';
import { ToastProvider } from './hooks/use-toast';
import { LoaderProvider } from './hooks/loader-context';
import AxiosLoader from './components/ui/axios-loading';
import { ToastProviderMultiple } from './hooks/use-toast-multiple';

declare global {
    const route: typeof routeFn;
}

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./pages/${name}.tsx`, import.meta.glob('./pages/**/*.tsx')),
    setup({ el, App, props }) {
        const root = createRoot(el);

        root.render(
            <LoaderProvider>
                <AxiosLoader />
                <ToastProvider>
                    <ToastProviderMultiple>
                        <App {...props} />
                    </ToastProviderMultiple>
                </ToastProvider>
            </LoaderProvider>
        );
    },
    progress: {
        color: '#4B5563',
    },
});

// This will set light / dark mode on load...
initializeTheme();
